import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { campaignsApi } from './campaigns'
import { queryKeys } from './query-keys'

/** Per-campaign follow-up funnel for a team (mock-only). */
export function useCampaignResults(teamId: number | string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.campaigns.results(teamId ?? 'none'),
    queryFn: () => campaignsApi.results(Number(teamId)),
    enabled: teamId != null,
  })
}

/** The team's running conversations, "waiting on you" first (mock-only).
 *  Polls — a reply landing while the inbox is open should surface itself. */
export function useInbox(teamId: number | string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.campaigns.inbox(teamId ?? 'none'),
    queryFn: () => campaignsApi.inbox(Number(teamId)),
    enabled: teamId != null,
    refetchInterval: 15_000,
  })
}

/** The follow-up engine's full report card for a team (mock-only). */
export function useMarketingAnalytics(teamId: number | string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.campaigns.analytics(teamId ?? 'none'),
    queryFn: () => campaignsApi.analytics(Number(teamId)),
    enabled: teamId != null,
  })
}

/** Bulk promotion to explicit customers (mock-only). Refreshes the inbox and
 *  every open thread — the sent message is part of each conversation. */
export function useSendPromotion() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ customerIds, body }: { customerIds: number[]; body: string }) =>
      campaignsApi.sendPromotion(customerIds, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.campaigns.all })
      qc.invalidateQueries({ queryKey: queryKeys.customerActivity.all })
    },
  })
}
